import { Sprite, Texture } from 'pixi.js';

import { HighlightType } from 'flow-builder/types/node';

export type HighlightTextureMap = Record<HighlightType, Texture>;
export type HighlightSpriteMap = Record<HighlightType, Sprite>;

export function createTextureSpriteMap(
  textureMap: HighlightTextureMap,
  name: string,
): HighlightSpriteMap {
  return Object.fromEntries(
    Object.entries(textureMap).map(([type, texture]) => {
      const sprite = new Sprite(texture);

      sprite.visible = false;
      sprite.anchor.set(0.5, 0.5);
      sprite.name = `${name} (${type})`;

      return [type, sprite];
    }),
  ) as HighlightSpriteMap;
}

export function setHighlightSpriteVisibility(
  types: HighlightSpriteMap,
  activeHighlightType: HighlightType,
): void {
  Object.entries(types).forEach(([textureHighightType, sprite]) => {
    if (textureHighightType === activeHighlightType) {
      sprite.visible = true;
      return;
    }

    sprite.visible = false;
  });
}
